import { color, font, query, space } from '@design/templateFns';
import styled from 'styled-components';

import { AspectBox } from '@components/Layout';

export const FieldWrapper = styled.div`
  flex: 0 0 100%;
  max-width: 100%;

  input,
  textarea {
    width: 100%;
    box-sizing: border-box;
  }
`;

export const Container = styled.div<{ $reverse?: boolean }>`
  display: grid;
  gap: 24px;
  @media screen and (${query.atLeast('desktop')}) {
    grid-template-columns: ${({ $reverse }) => ($reverse ? '2fr 1fr' : '1fr 2fr')};
  }
  @media screen and (${query.below('desktop')}) {
    gap: 0;
  }
`;

export const BottomBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 45%;
  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const FormWrapper = styled.div`
  a span {
    display: block;
  }

  button {
    border-radius: 4px;
  }
`;
export const FormInputGroup = styled.div`
  display: flex;
  gap: 12px;
`;

export const FormBox = styled.div``;

export const GridLeftContainer = styled.div<{ $reverse?: boolean }>`
  order: ${({ $reverse }) => ($reverse ? '0' : '-1')};
  display: flex;
  flex-direction: column;

  background-color: ${color('secondaryBg')};
  padding: ${space('x10')} ${space('xl')};

  @media screen and (${query.atLeast('tablet')}) {
    margin-top: 0;
    padding: ${space('x10')} ${space('x8')};
  }

  a span {
    justify-content: left;
  }
`;

export const GridRightContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 0;
  @media screen and (${query.atLeast('tablet')}) {
    flex-direction: column;
  }
`;

export const SideTextContainer = styled.div<{ $isSent?: boolean | null }>`
  display: ${({ $isSent }) => ($isSent ? 'none' : 'block')};
`;

export const BottomTextContainer = styled.div<{
  $backgroundColor?: boolean | string;
}>`
  display: flex;
  color: ${({ $backgroundColor }) => ($backgroundColor === 'cream' ? color('fg') : color('bg'))};

  background-color: ${({ $backgroundColor }) =>
    $backgroundColor === 'cream' ? '#FAF8F1' : color('fg')};

  flex-direction: row;
  justify-content: space-between;
  a span {
    justify-content: left;
  }
  padding: 44px 20px;
  @media screen and (${query.atLeast('tablet')}) {
    margin-top: 0;
    padding: 64px;
  }
  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const ContentContainer = styled.div<{ $reverse?: boolean }>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  grid-row: 2;
  text-align: center;

  @media screen and (${query.atLeast('tablet')}) {
    margin-top: 0;
    grid-row: ${({ $reverse }) => ($reverse ? 1 : 'unset')};
  }
`;

export const Eyebrow = styled.h3`
  text-transform: uppercase;
  color: ${color('cta')};
  ${font('eyebrow-md')};
  padding-bottom: 16px;
  margin-top: 0;
  font-size: 12px;

  @media screen and (${query.atLeast('tablet')}) {
    font-size: 14px;
  }
`;

export const Header = styled.h2`
  ${font('body-xs')};
  color: #666666;
  letter-spacing: 2px;
  line-height: 20px;
  margin: 16px 0 12px;
  padding: 0;
  text-align: center;
`;

export const Text = styled.div`
  p {
    color: ${color('fg')};
    ${font('headline-sm')}
    font-size: 28px;
    text-align: center;
    @media screen and (${query.below('tablet')}) {
      ${font('headline-xs')}
    }
  }
`;

export const BottomEyebrow = styled.div<{ $backgroundColor?: string | boolean }>`
  ${font('eyebrow-sm')};
  text-transform: uppercase;
  padding-bottom: 16px;
  color: ${({ $backgroundColor }) => ($backgroundColor === 'cream' ? color('cta') : color('bg'))};
  @media screen and (${query.atLeast('tablet')}) {
    font-size: 14px;
  }
`;

export const BottomHeader = styled.h2`
  ${font('headline-sm')};
  margin-top: 16px;
  padding: 0;
`;

export const BottomText = styled.div`
  ${font('body-md-light')};
  padding-bottom: 57px;
  div {
    p:last-child {
      margin-bottom: 0;
    }
  }
`;

export const ImageBox = styled(AspectBox).attrs({ $ratio: [1.79] })`
  flex: 1;
  padding-top: 65%;
  span {
    height: 100%;
  }
`;
